module.exports = __webpack_public_path__ + "static/media/shopping-hero-desktop.9b8921b0.jpg";